(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("singleSpa", [], factory);
	else if(typeof exports === 'object')
		exports["singleSpa"] = factory();
	else
		root["singleSpa"] = factory();
})(window, function() {
return 


// WEBPACK FOOTER //
// webpack://singleSpa/webpack/universalModuleDefinition